import styled from "styled-components";
import { Tag } from "antd";
import { theme } from "../../../config";

export const Wrapper = styled.div`
  vertical-align: middle;
`;

export const TagStyled = styled(Tag).attrs(
  (props: { $isHoverable: boolean }) => ({
    ...props,
  })
)`
  border-radius: 4px;
  margin: 0;
  color: ${theme.colors.gray6};
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
  ${(props) => {
    return props.$isHoverable
      ? `&:hover {
      border-color: rgba(255, 255, 255, 0.3) !important;
      box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.3) !important;
    }`
      : "";
  }}
`;
